import './StepByStep.5f9314a151df6a499b7806e20033786c.css';
export default {"stepByStep":"_stepByStep_16f31_1","fade-in":"_fade-in_16f31_1","variantGRAY":"_variantGRAY_16f31_1"};